'use strict';

angular.module('webAgro1App').factory('RequestInterceptorService',
  // eslint-disable-next-line
  function($rootScope, $q, StorageService, CommonHTTPService, Flash, LoadingService) {
    const NO_PROPRIEDADE = -1;

    return {
      request,
      response,
      responseError
    };

    function response(responseObject) {
      const { data } = (responseObject.data || {});

      if (data instanceof Array) {
        responseObject.data = data.map((item) => item.attributes);
      }

      return responseObject;
    }

    function _checkParams(config, hasPropertyOnData) {
      const newConfig = { ...config };

      if (!newConfig.params) {
        newConfig.params = {};
      }
      if (!hasPropertyOnData && !newConfig.params.propriedade &&
          $rootScope.currentPropriedade && $rootScope.currentPropriedade.id) {
        newConfig.params.propriedade = $rootScope.currentPropriedade.id;
      }

      if (newConfig.params.propriedade === NO_PROPRIEDADE) {
        delete newConfig.params.propriedade;
      }

      return newConfig;
    }

    function request(config) {
      const user = StorageService.get(KEY_USER);
      if (user && !config.headers.Authorization) {
        config.headers.Authorization = `Token ${ user.token}`;
      }

      const hasPropertyOnData = config.data && config.data.propriedade;

      if (window.SERVER && config.url.includes(window.SERVER)) {
        config = _checkParams(config, hasPropertyOnData);
      }

      return config;
    }

    function responseError(rejection) {
      if (CommonHTTPService.isUnauthorized(rejection.status)) {
        if ($rootScope.signedIn) {
          Flash.create('danger', 'Erro de autenticação. Faça login novamente.');
          $rootScope.doLogout();
          LoadingService.hideLoading();
          location.reload();
        }
      }

      return $q.reject(rejection);
    }
  });
